import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import TheLogin from "@/components/Common/TheLogin";
import TheTeams from "@/components/Admin/TheTeams";
import TheTeam from "@/components/Admin/TheTeam";
import ThePrompt from "@/components/Admin/ThePrompt";
import TheHackathon from "@/components/Admin/TheHackathon";

const router =  createRouter ({
    history: createWebHistory(),
    routes:[

        {
            path: '/',
            component: TheLogin,
            meta: {
                title: 'Авторизация',
                layout: 'login',
                auth: false
            },
            name: 'login',
        },

        // закрытые маршруты
        {
            path: '/teams',
            component: TheTeams,
            meta: {
                title: "Команды",
                layout: 'admin',
                auth: true
            },
            name: 'teams',
        },

        {
            path: '/about',
            component: TheHackathon,
            meta: {
                title: "О мероприятии",
                layout: 'admin',
                auth: true
            },
            name: 'hackathon',
        },

        {
            path: '/team/:id/:task?',
            component: TheTeam,
            meta: {
                title: "Команда",
                layout: 'admin',
                auth: true
            },
            name: 'team',
        },

        {
            path: '/prompt/:id?',
            component: ThePrompt,
            meta: {
                title: "Промпт",
                layout: 'admin',
                auth: true
            },
            name: 'prompt',
        },

        {
            path: '/:notFound(.*)', redirect: '/'
        },
    ],

    // переопределить классы активных ссылок
    linkActiveClass: 'active',
    linkExactActiveClass: 'active'
})


router.beforeEach((to, from, next) =>{
    document.title = to.meta.title
    const requireAuth = to.meta.auth
    let toDefaultRoute = false

    // если авторизован, но на страницу входа не попасть
    if (to.path === '/' && store.getters['authModule/isAuth']){
        toDefaultRoute = true
    }

    if (!requireAuth || (requireAuth && store.getters['authModule/isAuth'])){

        if (toDefaultRoute){
            next('/teams')
        } else {
            next()
        }

    } else if (requireAuth && !store.getters['authModule/isAuth']){
        // редирект неавторизованных пользователей на '/'
        next('/')
    }
});

export default router;